import React from 'react';
import {HoverBox, Eye, DeleteImage} from '../Style/NewClassImages.style';
import useAutoClassGallery from '../../AutoClassGallery/Controller/AutoClassGallery.controller';


const HoverImageBox = ({ onDeleteFile, itemData, chosenImage, open, setOpen, setCurrentImage, setCurrentImageIndex}) => {
    const {handleOpenGalleryBtnClick} = useAutoClassGallery({ itemData, chosenImage, open, setOpen, setCurrentImageIndex, onDeleteFile, setCurrentImage});

    return (
        <HoverBox id='img_hover'>
            <DeleteImage id='img_hover_delete' onClick={onDeleteFile}/>
            <Eye id='img_hover_show' onClick={() => handleOpenGalleryBtnClick()}/>
        </HoverBox>
    );
};

export default HoverImageBox;
